var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('span',{staticClass:"spinner",class:{ 'spinner--small': _vm.isSmall }},[_c('img',{staticClass:"ufo-img",attrs:{"src":require("../assets/img/game-play-img.png"),"alt":"Game play image"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }